import { Theme, css } from '@emotion/react';

export const walkinWaitlistDialogRoot = ({ breakpoints, spacing }: Theme) => css`
  ${breakpoints.up('md')} {
    align-items: center;
    padding: ${spacing(4)};
  }
  & > p {
    margin-bottom: ${spacing(3)}px;
  }
`;

export const walkinWaitlistAlertRoot = ({ spacing }: Theme) => css`
  margin-bottom: ${spacing(3)}px;
  margin-top: ${spacing(3)}px;
`;

export const walkinWaitlistBusinessSummaryRoot = ({ spacing }: Theme) => css`
  display: flex;
  margin-bottom: ${spacing(3)}px;
`;

export const walkinWaitlistBusinessSummaryContent = css`
  align-self: center;
`;

export const walkinWaitlistBusinessImage = ({ borderRadius, spacing }: Theme) => css`
  border-radius: ${borderRadius[100]};
  margin-right: ${spacing(2)}px;
`;
